module.exports = __webpack_public_path__ + "img/microsoft.0f311e88.svg";